import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

// Create taskComments API
const taskCommentsAPI = createApi({
    reducerPath: "taskCommentsAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        // taskComments management Endpoints

        //Add Comment
        addTaskComment: builder.mutation({
            query: (data) => ({
                url: `TaskComment/AddTaskComment`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTaskComment:builder.query({
            query:(taskId)=>({
                url:`TaskComment/GetAllTaskComments?taskId=${taskId}`,
                method:'GET'
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse
        }),
        deleteTaskComment:builder.mutation({
            query: (taskCommentId) => ({
                url: `TaskComment/DeleteTaskComment?TaskCommentId=${taskCommentId}`,
                method: 'DELETE',
                body: transformRequest(taskCommentId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateTaskComment: builder.mutation({
            query: (data) => ({
                url: 'TaskComment/UpdateTaskComment',
                method: 'POST',
                body: transformRequest(data)
            }), 
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

// Extract hooks for easy access to various API requests 
export const {
   useAddTaskCommentMutation,
   useLazyGetAllTaskCommentQuery,
   useDeleteTaskCommentMutation,
   useUpdateTaskCommentMutation
} = taskCommentsAPI;

export default taskCommentsAPI;